import { Component, OnInit,ViewChild } from '@angular/core';
import { InvoiceService} from 'app/shared/services/invoice.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HttpErrorResponse } from '@angular/common/http';
import { NbThemeService } from '@nebular/theme';
import { AuthService } from 'app/shared/services/auth.service';


@Component({
  selector: 'app-sale-return-list',
  templateUrl: './sale-return-list.component.html',
  styleUrls: ['./sale-return-list.component.css']
})
export class SaleReturnListComponent implements OnInit {

  displayedColumns: string[] = ['type','invoiceNo', 'invoiceDate', 'customer', 'amount','status','createdBy','action'];

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dataSource :MatTableDataSource<any>
  searchKey : string;
  isDark: boolean = false;

  invoices : any[]=[];
  invoiceList : any[]=[];

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };
  

  constructor(
              private invoiceService : InvoiceService, 
              private router : Router, 
              private themeService: NbThemeService,
              private route : ActivatedRoute, 
              private authService: AuthService,
             ) { }

  ngOnInit() {

    this.getAllInvoices();
    this.getControlPermissions();
    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });
    
  }

  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='SR'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }

    newButtonClick(){
    this.router.navigate(['../sale-return'],{relativeTo : this.route});
    }


  getAllInvoices(){
    this.invoiceService.getAll()
     .subscribe(
        (data) => {

                  this.invoices = data;
                  this.invoiceList = this.invoices.filter((el)=>{
                    return el.Type ==='Credit Note';
                  }); 
                  this.dataSource = new  MatTableDataSource (this.invoiceList);  
                  this.dataSource.sort = this.sort;
                  this.dataSource.paginator = this.paginator;      
                   
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  

       
       
     }
   

     viewDetailsButtonClick(returnNo : string){     
        this.router.navigate(['../sale-return'],{queryParams : {'returnNo':returnNo},relativeTo : this.route});       
     }



   applyFilter(){
    this.dataSource.filter =this.searchKey.trim().toLowerCase();

   }
   onSearchClear(){
     this.searchKey = "";
     this.applyFilter();
   }


}
